import ScrollToTop from "@/components/feature/ScrollToTop";
import BackToTop from "@/components/feature/BackToTop";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useSeo, SITE_ORIGIN } from "@/hooks/useSeo";
import { brand } from "@/mocks/site";
import Hero from "@/pages/home/components/Hero";
import Ticker from "@/pages/home/components/Ticker";
import VerdictGuide from "@/pages/home/components/VerdictGuide";
import FeaturedChecks from "@/pages/home/components/FeaturedChecks";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestChecks from "@/pages/home/components/LatestChecks";
import DebunkTeaser from "@/pages/home/components/DebunkTeaser";
import MethodSteps from "@/pages/home/components/MethodSteps";
import Voices from "@/pages/home/components/Voices";
import FaqPreview from "@/pages/home/components/FaqPreview";
import CtaBand from "@/pages/home/components/CtaBand";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: brand.name,
      alternateName: brand.fullName,
      url: SITE_ORIGIN,
      description: brand.description,
      email: brand.email,
      knowsAbout: brand.keywords,
    },
    {
      "@type": "WebSite",
      name: brand.name,
      url: SITE_ORIGIN,
      description: brand.tagline,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: `${SITE_ORIGIN}/gossip?q={search_term_string}`,
        },
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "WebPage",
      name: `${brand.name} | 真假鉴定与实锤分析`,
      url: SITE_ORIGIN,
      description: brand.description,
      isPartOf: { "@type": "WebSite", url: SITE_ORIGIN },
      about: ["爆料真假鉴定", "实锤分析", "证据链整理", "可信度评估", "辟谣汇总"],
    },
  ],
};

export default function Home() {
  useSeo({
    title: "瓜田爆料 | 真假鉴定与实锤分析 · 爆料可信度评估",
    description:
      "瓜田爆料专注爆料可信度鉴定，提供真假鉴定、实锤分析、证据链整理和辟谣汇总。针对热门瓜进行可信度评估，帮你分辨真伪，看清事件全貌。",
    keywords: ["瓜田爆料", "真假鉴定", "实锤分析", "证据链", "辟谣汇总", "可信度评估", "实锤整理"],
    path: "/",
    ogType: "website",
    jsonLd,
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <ScrollToTop />
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <Ticker />
        <VerdictGuide />
        <FeaturedChecks />
        <CategoryGrid />
        <LatestChecks />
        <DebunkTeaser />
        <MethodSteps />
        <Voices />
        <FaqPreview />
        <CtaBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}